import React from 'react';
import { Field } from '../../components/ui';
import ContactSync from './ContactSync';

const Row = ({ label, value }) => (
  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12, padding: '9px 0', borderBottom: '1px solid var(--line)' }}>
    <span className="muted" style={{ fontSize: 13 }}>{label}</span>
    <span style={{ fontWeight: 600, textAlign: 'right' }}>{value || '—'}</span>
  </div>
);

// Desktop Profile — two columns on a wide screen (the account on the left,
// "my side" + phone contacts on the right), one column when narrow; never
// stretched across a big monitor.
export default function ProfileDesktop({ vm }) {
  const {
    user, organiser, roleLabel, fullName, avatar, editing, setEditing, saving, form, setF, saveProfile, doLogout, goChangePassword,
    event, isMarriage, mySide, sideOptions, chooseSide, savingSide,
  } = vm;
  return (
    <div>
      <div className="page-head"><h1>My Profile</h1></div>

      <div className="pp-profile">
        <div className="pp-col">
          <div className="card card-pad">
            <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 6 }}>
              <div className="avatar avatar-lg">{avatar}</div>
              <div>
                <div style={{ fontSize: 18, fontWeight: 700 }}>{fullName || '—'}</div>
                <div className="muted" style={{ fontSize: 13 }}>{roleLabel}</div>
              </div>
            </div>

            {editing ? (
              <div className="form-grid pp-profile-edit" style={{ marginTop: 12 }}>
                <Field label="Name" autoComplete="given-name" value={form.Name} required onChange={v => setF('Name', v)} />
                <Field label="Surname" autoComplete="family-name" value={form.Surname} onChange={v => setF('Surname', v)} />
                <Field label="Mobile Number" type="tel" autoComplete="tel-national" value={form.MobileNumber} required onChange={v => setF('MobileNumber', v)} />
                <Field label="Email" type="email" autoComplete="email" value={form.EmailId} onChange={v => setF('EmailId', v)} />
                <Field label="New Password" type="password" autoComplete="new-password" value={form.Password}
                  onChange={v => setF('Password', v)} placeholder="Leave blank to keep current password" />
                <Field label="Confirm Password" type="password" autoComplete="new-password" value={form.ConfirmPassword}
                  onChange={v => setF('ConfirmPassword', v)} />
              </div>
            ) : (
              <>
                <Row label="User ID" value={user?.UserId} />
                <Row label="Name" value={fullName} />
                <Row label="Mobile Number" value={user?.MobileNumber} />
                <Row label="Email" value={user?.EmailId} />
                <Row label="Organiser" value={organiser?.OrganiserName} />
                <Row label="Role" value={roleLabel} />
                {isMarriage && <Row label="My side" value={mySide ? `${mySide} side` : 'Both / Common'} />}
              </>
            )}

            <div style={{ display: 'flex', gap: 8, marginTop: 14, flexWrap: 'wrap' }}>
              {editing ? (
                <>
                  <button className="btn light" style={{ flex: 1 }} disabled={saving} onClick={() => setEditing(false)}>Cancel</button>
                  <button className="btn primary" data-save="primary" title="Ctrl+S" style={{ flex: 1 }} disabled={saving} onClick={saveProfile}>{saving ? 'Saving...' : 'Save Profile'}</button>
                </>
              ) : (
                <>
                  <button className="btn primary" style={{ flex: 1 }} onClick={() => setEditing(true)}>Edit Profile</button>
                  <button className="btn light" style={{ flex: 1 }} onClick={goChangePassword}>Change password</button>
                  <button className="btn danger" style={{ flex: 1 }} onClick={doLogout}>Logout</button>
                </>
              )}
            </div>
          </div>
        </div>

        <div className="pp-col">
          {/* Which family this user works for — decided here, once. Every guest
              they add afterwards inherits it, so no other screen asks. */}
          {isMarriage && (
            <div className="card card-pad">
              <div className="step-label">My side for {event?.EventName}</div>
              <div className="pp-seg">
                {sideOptions.map(s => (
                  <button key={s} type="button" disabled={!!savingSide}
                    className={mySide === s || (!mySide && s === 'Common') ? 'on' : ''}
                    onClick={() => chooseSide(s)}>
                    {savingSide === s ? '…' : s === 'Common' ? 'Both / Common' : `${s} side`}
                  </button>
                ))}
              </div>
              <div className="muted" style={{ fontSize: 12, marginTop: 6 }}>
                Guests you add are counted on this side automatically.
              </div>
            </div>
          )}
          <ContactSync user={vm.user} />
        </div>
      </div>
    </div>
  );
}
